<template>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group form-group-1 ">
                <label :for="'language-' + language.id"
                       class="form-label"
                >
                    Foreign languages?
                </label>
                <select class="custom-select"
                        v-model="language.id"
                        :id="'language-' + language.id"
                >
                    <option v-for="language in languagesList"
                            :value="language.id"
                            :selected="language.id"
                    >
                        {{ language.name }}
                    </option>
                    <option :value="null" >Other</option>
                </select>
            </div>
        </div>
        <div class="col-md-3" >
            <div class="form-group form-group-1">
                <label for="" class="form-label">Other</label>
                <input type="text" class="form-control"
                       v-model="language.other"
                       :disabled="language.id !== null">
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group form-group-1">
                <label for="" class="form-label">Speak</label>
                <div class="buttons-type-multiselect two-btns">
                    <div  class="item">
                        <input type="radio"
                               :name="'speak-' + language.id"
                               class="rad" :id="'speak-yes-' + language.id"
                               value="1"
                               v-model="language.speak">
                        <label :for="'speak-yes-' + language.id">
                            <div class="ttl">Yes</div>
                        </label>
                    </div>

                    <div class="item">
                        <input type="radio"
                               class="rad"
                               :name="'speak-' + language.id"
                               :id="'speak-no-' + language.id"
                               value="0" v-model="language.speak">
                        <label :for="'speak-no-' + language.id">
                            <span class="ttl">No</span>
                        </label>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ForeignLanguageInput",
    props: {
        language:{
            type: Object,
            required: true,
        },
        languagesList: {
            type: Array,
            required: true
        },
    },
    watch: {
        'language.id': function (newId) {
            if (newId !== null) {
                this.language.other = null;
            }
        },
    },
    mounted() {
        if ( this.language.id === null) {
            this.language.id = 1
        }
    },
}

</script>

<style scoped>

</style>
